import { useMutation } from '@tanstack/react-query';

import { Agents } from '@air/api';
import { callAirApi } from '@air/utils-api';

export type UsePrivateWorkspaceAgentSessionElicitationRespondMutationParams = NonNullable<
  Parameters<typeof Agents.Sessions.Elicitations.respond>[0]
>;

export const usePrivateWorkspaceAgentSessionElicitationRespondMutation = () =>
  useMutation({
    mutationFn: async (params: UsePrivateWorkspaceAgentSessionElicitationRespondMutationParams) =>
      callAirApi(() => Agents.Sessions.Elicitations.respond(params)),
  });
